// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"654107fe979e9520311f","655":"b387b02101b8d0095bac"}[chunkId] + ".js";
};